/**
 * POST /v1/content/:contentId/resend-notifications
 *
 * Re-sends a published content record's push notification to its targets.
 * Mirrors `apps/backend/src/api/content/v1/use-cases/(core)/resend-notifications/schema.ts`.
 */

import { z } from 'zod'

export const ResendContentNotificationsResponseSchema = z.object({
  message: z.string(),
  data: z.object({
    notificationsEnabled: z.boolean(),
    usersReached: z.number().optional(),
    groupsTargeted: z.number().optional()
  })
})

export type ResendContentNotificationsResponse = z.infer<typeof ResendContentNotificationsResponseSchema>
